import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./arcgis-items.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./arcgis-items.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ArcgisItemsConstants, ArcGisItmHeadingEnumLookup } from "./arcgis-items.constants";
import { ArcGisItmHeadingEnum } from "../../core/settings/components/arcgis-item/arcgis-item.const";
import { BehaviorSubject, Subject } from "rxjs";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
import { StepService } from "../../step/step.service";
import { AppControllerService } from "../../app-controller.service";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
import { take, takeUntil } from "rxjs/operators";
let ArcgisItemsComponent = class ArcgisItemsComponent {
    stepService;
    changeDetectorRef;
    appControllerService;
    _destroy$ = new Subject();
    pageHeading = ArcgisItemsConstants.Headings.PageHeadings;
    tableMapper = ArcGisItmHeadingEnumLookup;
    dataSource = new BehaviorSubject([]);
    urlText = ArcGisItmHeadingEnum.url;
    constructor(stepService, changeDetectorRef, appControllerService) {
        this.stepService = stepService;
        this.changeDetectorRef = changeDetectorRef;
        this.appControllerService = appControllerService;
    }
    ngOnInit() {
        this.getArcGisItems();
    }
    getArcGisItems() {
        const params = {
            $select: "id, name, category, url",
            $filter: `moduleId eq ${+this.appControllerService.selectedModuleID} and disabled eq false`
        };
        this.stepService.getArcGisItemsObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (arcGisItems) => {
                if (arcGisItems.length > 0) {
                    arcGisItems.forEach(item => {
                        item.url = decodeURIComponent(item.url);
                    });
                    this.dataSource.next(arcGisItems);
                    this.changeDetectorRef.detectChanges();
                }
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ArcgisItemsConstants.StepName, error, CRUDOperation.Get);
            }
        });
    }
    onUrlClicked(arcgisItemUrl) {
        if (arcgisItemUrl) {
            window.open(arcgisItemUrl, "_blank");
        }
    }
    static ctorParameters = () => [
        { type: StepService },
        { type: ChangeDetectorRef },
        { type: AppControllerService }
    ];
};
ArcgisItemsComponent = __decorate([
    Component({
        selector: "app-arcgis-items",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ArcgisItemsComponent);
export { ArcgisItemsComponent };
